import React from 'react';
import { Shield, Target, Users, Lightbulb } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Shield,
      title: 'Trust',
      description: 'We build trust through transparency, security, and reliable service. Every feature is designed with compliance in mind.'
    },
    {
      icon: Target,
      title: 'Clarity',
      description: 'Complex compliance made simple. Clear processes, straightforward pricing, and no hidden surprises.'
    },
    {
      icon: Users,
      title: 'Control',
      description: 'You own your data and decisions. We provide the tools; you maintain control of your compliance.'
    },
    {
      icon: Lightbulb,
      title: 'Calm',
      description: 'Compliance doesn\'t have to be stressful. Our quiet, confident approach keeps you focused on your business.'
    }
  ];

  return (
    <div className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mission */}
        <div className="text-center mb-20">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">About Acquiva</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We're building the modern compliance infrastructure for professional services companies.
            Our mission is to make client due diligence simple, fast, and audit-grade — without
            the paperwork chase.
          </p>
        </div>

        {/* Values */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-12">Our Values</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{value.title}</h3>
                  <p className="text-gray-600 text-sm">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Story */}
        <div className="bg-gray-50 rounded-2xl p-8 lg:p-12">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Story</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                Acquiva was founded by compliance professionals who were frustrated with the 
                state of KYC and KYB processes. Spreadsheets, email chases, and manual document 
                collection were the norm — and they were slowing down business while creating 
                compliance risks.
              </p>
              <p>
                We set out to build a platform that would make due diligence effortless for both
                companies and their clients. A platform that produces audit-grade evidence, supports
                professional judgment, and scales with your business.
              </p>
              <p>
                Today, Acquiva serves law firms, accountants, corporate service providers, and 
                financial advisory firms across the UK, EU, and US. We're proud to be the quiet, 
                reliable infrastructure behind their compliance operations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
